import { render, staticRenderFns } from "./MailMagazine.vue?vue&type=template&id=05374c7a&"
import script from "./MailMagazine.vue?vue&type=script&lang=ts&"
export * from "./MailMagazine.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports